import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";
import { maintenanceTypes } from "./maintenance-types";

// ============================================================================
// maintenance_records — บันทึกการซ่อมบำรุง
// ============================================================================
export const maintenanceRecords = sqliteTable("fleet_maintenance_records", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  maintenanceNo: text("maintenance_no").notNull(),
  maintenanceTypeId: text("maintenance_type_id").references(() => maintenanceTypes.id),
  serviceDate: text("service_date").notNull(),
  completionDate: text("completion_date"),
  mileageAtService: real("mileage_at_service"),
  description: text("description"),
  partsDetail: text("parts_detail"), // JSON string
  laborCost: real("labor_cost").default(0),
  partsCost: real("parts_cost").default(0),
  totalCost: real("total_cost").default(0),
  garageName: text("garage_name"),
  // #401 — Optional soft FK to accounting_partners.id. Hybrid with `garageName`:
  // when both are set, the partner is the canonical reference, `garageName` is
  // kept as a convenience snapshot so legacy readers don't break.
  garagePartnerId: text("garage_partner_id"),
  garageContact: text("garage_contact"),
  invoiceRef: text("invoice_ref"),
  paymentId: text("payment_id"),
  nextServiceKm: real("next_service_km"),
  nextServiceDate: text("next_service_date"),
  status: text("status", {
    enum: ["scheduled", "in_progress", "completed", "cancelled"],
  })
    .notNull()
    .default("scheduled"),
  // #415 — Soft FK to workflow module's `workflows.id`. Nullable for
  // back-compat with pre-#415 rows; new rows get populated at create time
  // from the default maintenance workflow seeded per-company.
  workflowId: text("workflow_id"),
  notes: text("notes"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type MaintenanceRecord = typeof maintenanceRecords.$inferSelect;
export type NewMaintenanceRecord = typeof maintenanceRecords.$inferInsert;
